export enum StopwatchStatus {
  Running = 'running',
  Paused = 'paused',
}

export interface Stopwatch {
  id: string;
  status: StopwatchStatus;
  accumulatedSeconds: number;
  startedAt: string | null;
  taskKey: string | null;
  taskTitle: string | null;
  queueKey: string | null;
  queueName: string | null;
  comment: string;
  logAt: string;
  createdAt: string;
  updatedAt: string | null;
}

export interface CreateStopwatchRequest {
  comment?: string;
  taskKey?: string | null;
  taskTitle?: string | null;
  queueKey?: string | null;
  queueName?: string | null;
  logAt?: string;
}

export interface UpdateStopwatchRequest {
  comment?: string | null;
  taskKey?: string | null;
  taskTitle?: string | null;
  queueKey?: string | null;
  queueName?: string | null;
  accumulatedSeconds?: number | null;
  logAt?: string | null;
}

export interface PauseStopwatchRequest {
  accumulatedSeconds: number;
  startedAt: string;
}
